import React from "react";
import { CheckCircle2, XCircle, HelpCircle } from "lucide-react";

interface StatusCardProps {
  status?: string | null;
  title: string;
  subtitle?: string;
}

const STATUS_PRESENTATION: Record<
  string,
  { label: string; icon: React.ReactNode; classes: string }
> = {
  passed: {
    label: "Pass",
    icon: <CheckCircle2 className="h-8 w-8 text-green-600" />,
    classes: "bg-green-50 border-green-200",
  },
  approved: {
    label: "Approved",
    icon: <CheckCircle2 className="h-8 w-8 text-blue-600" />,
    classes: "bg-blue-50 border-blue-200",
  },
  approve_deviation: {
    label: "Approved Under Deviation",
    icon: <CheckCircle2 className="h-8 w-8 text-yellow-600" />,
    classes: "bg-yellow-50 border-yellow-200",
  },
  failed: {
    label: "Fail",
    icon: <XCircle className="h-8 w-8 text-red-600" />,
    classes: "bg-red-50 border-red-200",
  },
  rejected: {
    label: "Rejected",
    icon: <XCircle className="h-8 w-8 text-red-600" />,
    classes: "bg-red-50 border-red-200",
  },
};

/** Large banner-style card making pass/fail status immediately visible at the top of Overview. */
export const StatusCard: React.FC<StatusCardProps> = ({ status, title, subtitle }) => {
  const key = (status || "").toLowerCase().trim();
  const presentation = STATUS_PRESENTATION[key] ?? {
    label: status || "Pending",
    icon: <HelpCircle className="h-8 w-8 text-gray-400" />,
    classes: "bg-gray-50 border-gray-200",
  };

  return (
    <div className={`rounded-lg border p-5 flex items-center gap-4 ${presentation.classes}`}>
      {presentation.icon}
      <div>
        <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">{title}</p>
        <p className="text-2xl font-bold text-gray-900">{presentation.label}</p>
        {subtitle && <p className="text-sm text-gray-600 mt-0.5">{subtitle}</p>}
      </div>
    </div>
  );
};
